export default {
  onboardingData: {},
  onboardingDataLoading: false,
  onboardingUpdateLoading: false,

  treeUsageTutorial: null,
};
